var render = function render(){var _vm=this,_c=_vm._self._c;return (this.redirect)?_c('a',{staticClass:"btn bxs",class:[
        'btn-' + _vm.bg,
        'btn-' + _vm.size
    ],attrs:{"href":this.redirect,"target":"_blank"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.$store.state.translations.to_application || 'Till ansökan'))]),_vm._v(" "),(_vm.icon)?_c('i',{staticClass:"p h margin-left-2",class:_vm.icon}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }